export const APPLE_STORE_URL = 'https://apps.apple.com/us/app/justpush-io/id6738397112'
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.justpush'

